export const createRequestId = (actionName, id) => `${actionName}_${id}`;
export default createRequestId;
